(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@wufe/particles"));
	else if(typeof define === 'function' && define.amd)
		define(["@wufe/particles"], factory);
	else if(typeof exports === 'object')
		exports["LiquidParticleSystem"] = factory(require("@wufe/particles"));
	else
		root["LiquidParticleSystem"] = factory(root["@wufe/particles"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__wufe_particles__) {
return 